import { StripeElementStyle } from '@stripe/stripe-js';
import styled from 'styled-components';

import { inputHighlightColor } from 'components/Input';
import { colors, fonts } from 'theme';

export const stripeElementStyles: StripeElementStyle = {
  base: {
    fontSize: '18px',
    fontFamily: fonts.sans,
  },
};

export const StripeElementContainer = styled.div`
  .StripeElement {
    height: 45px;
    border: solid 1px
      var(--input-highlight-color, ${inputHighlightColor('neutral', 'default')});
    border-radius: 4px;
    padding: 11px 18px;
    color: ${colors.charcoalGrey} !important;

    &--complete {
      --input-highlight-color: ${inputHighlightColor('success', 'default')};
    }

    &--invalid {
      --input-highlight-color: ${inputHighlightColor('error', 'default')};
    }

    &--complete,
    &--invalid {
      box-shadow: 0 0 0 1px var(--input-highlight-color);
    }

    input::placeholder {
      color: ${colors.middleGrey};
    }

    &--focus {
      border-color: ${colors.waterBlue};
      box-shadow: 0 0 0 1px ${colors.waterBlue};
      --input-affix-color: ${colors.waterBlue};
    }
  }
`;
